import { Menu } from 'antd';
import cn from 'classnames';
import { AppExpandIcon } from 'shared/UI/UIKit/icons/Expand';
import type { MenuProps } from 'antd';
import type { SidebarMenuProps } from './SidebarMenu.types';
import styles from './SidebarMenu.module.scss';

export const SidebarMenu = ({ menuItems, children, isStickyItems }: SidebarMenuProps) => {
  const renderExpandIcon: MenuProps['expandIcon'] = ({ isOpen }) => (
    <AppExpandIcon
      className={cn(styles['expand-icon'], {
        [styles['expand-icon_open']]: isOpen,
      })}
    />
  );

  return (
    <div className={cn(styles['menu-container'], isStickyItems && styles['sticky-container'])}>
      <Menu
        mode="inline"
        items={menuItems}
        selectable={false}
        expandIcon={renderExpandIcon}
        className={cn(styles.menu, isStickyItems && styles['sticky-menu'])}
      />

      {children}
    </div>
  );
};
